import axios from "./axios";
import { handleApiError } from "./handleApiError";

export interface AdminContentRoyalty {
  contentId: string;
  creatorId: string;
  title: string;
  premiumReadCount: number;
  freeReadCount: number;
  singleUnlockCount: number;
  grossTokenAmount: number;
  shareTokenAmount: number;
  currencyAmount: number;
  currencyCode: string;
  cycleStartUtc?: string;
  cycleEndUtc?: string;
  daysElapsed?: number;
  daysRemaining?: number;
}

export interface AdminCreatorRoyalty {
  creatorId: string;
  creatorName: string;
  creatorEmail?: string;
  cycleStartUtc: string;
  cycleEndUtc: string;
  daysElapsed: number;
  daysRemaining: number;
  grossTokenAmount: number;
  shareTokenAmount: number;
  currencyAmount: number;
  currencyCode: string;
  contents: AdminContentRoyalty[];
}

export async function searchCreatorRoyalties(query: string, take = 5) {
  try {
    const response = await axios.get<AdminCreatorRoyalty[]>("/admin/royalties/creators", {
      params: { query, take },
    });
    return response.data ?? [];
  } catch (error) {
    return handleApiError(error, "searchCreatorRoyalties", []);
  }
}

export async function searchContentRoyalties(query: string, take = 5) {
  try {
    const response = await axios.get<AdminContentRoyalty[]>("/admin/royalties/contents", {
      params: { query, take },
    });
    return response.data ?? [];
  } catch (error) {
    return handleApiError(error, "searchContentRoyalties", []);
  }
}
